import { Router } from "./router/Router"

export const App = () => {
  return <Router/>
}